export default __webpack_public_path__ + "static/media/oralstop-logo.e450ae77.png";